import { component } from 'picoapp';

interface FeatureSingleConfig {
  timerEnabled: boolean
  timerHour: number
  timerMinute: number
}

export default component(async (node) => {
  const hourCircle = node.querySelector<HTMLElement>('[data-hour-circle]');
  const minuteCircle = node.querySelector<HTMLElement>('[data-minute-circle]');
  const secondCircle = node.querySelector<HTMLElement>('[data-second-circle]');
  const hourCount = node.querySelector('[data-hour-count]');
  const minuteCount = node.querySelector('[data-minute-count]');
  const secondCount = node.querySelector('[data-second-count]');

  const config: FeatureSingleConfig = JSON.parse(node.dataset.config);
  const { timerEnabled, timerHour, timerMinute } = config;

  const initTimer = () => {
    if (!timerEnabled) return;

    const MILISECONDS_IN_A_SECOND = 1000;
    const SECONDS_IN_A_MINUTE = 60;
    const MINUTES_IN_AN_HOUR = 60;
    const SECONDS_IN_AN_HOUR = 3600;
    const HOURS_IN_A_DAY = 24;
    const DEGREES_IN_A_CIRCLE = 360;

    const currentDate = new Date();
    const targetDate = new Date(currentDate.getTime());

    targetDate.setHours(timerHour);
    targetDate.setMinutes(timerMinute);
    targetDate.setSeconds(0);

    // if time passed for today, set to tomorrow
    if (targetDate < currentDate) {
      targetDate.setDate(targetDate.getDate() + 1);
    }

    const interval = setInterval(() => {
      currentDate.setSeconds(currentDate.getSeconds() + 1);

      const miliseconds = targetDate.getTime() - currentDate.getTime();

      if (miliseconds < 0) {
        clearInterval(interval);
        initTimer();
      }

      const totalSeconds = miliseconds / MILISECONDS_IN_A_SECOND;
      const hours = Math.floor(totalSeconds / SECONDS_IN_AN_HOUR);
      const minutes = Math.floor((totalSeconds % SECONDS_IN_AN_HOUR) / MINUTES_IN_AN_HOUR);
      const seconds = Math.floor(totalSeconds % SECONDS_IN_A_MINUTE);

      hourCount.textContent = hours.toString();
      minuteCount.textContent = minutes.toString();
      secondCount.textContent = seconds.toString();

      const hourPercentage = Math.floor(((HOURS_IN_A_DAY - hours) / HOURS_IN_A_DAY) * 100);

      const minutePercentage = (
        Math.floor(((MINUTES_IN_AN_HOUR - minutes) / MINUTES_IN_AN_HOUR) * 100)
      );

      const secondPercentage = (
        Math.floor(((SECONDS_IN_A_MINUTE - seconds) / SECONDS_IN_A_MINUTE) * 100)
      );

      const hourDegrees = (DEGREES_IN_A_CIRCLE / 100) * hourPercentage;
      const minuteDegrees = (DEGREES_IN_A_CIRCLE / 100) * minutePercentage;
      const secondDegrees = (DEGREES_IN_A_CIRCLE / 100) * secondPercentage;

      hourCircle.style.setProperty('--progress-deg', `${hourDegrees}deg`);
      minuteCircle.style.setProperty('--progress-deg', `${minuteDegrees}deg`);
      secondCircle.style.setProperty('--progress-deg', `${secondDegrees}deg`);
    }, 1000);
  };

  const init = () => {
    initTimer();
  };

  init();
});
